import { useNavigate } from "@tanstack/react-router";
import { useIntl } from "react-intl";

import { Tab, Tabs } from "@/components/Tabs";
import { rudderAnalytics, HomeTrackingEvents } from "@/lib/rudderstack";

type SearchCategorySwitcherProps = {
  current: "flights" | "hotels";
};

export const SearchCategorySwitcher = ({
  current,
}: SearchCategorySwitcherProps) => {
  const intl = useIntl();
  const navigate = useNavigate();

  return (
    <Tabs
      value={current}
      onChange={(newCategory) => {
        if (newCategory === "flights") {
          rudderAnalytics.track(HomeTrackingEvents.USER_CLICKED_HOME_SERVICE, {
            service: "flight",
          });

          navigate({
            to: "/flights/search",
            replace: true,
          });

          return;
        }

        rudderAnalytics.track(HomeTrackingEvents.USER_CLICKED_HOME_SERVICE, {
          service: "hotel",
        });

        navigate({
          to: "/hotels/search",
          replace: true,
        });
      }}
    >
      <Tab
        value="flights"
        label={intl.formatMessage({
          description: "Navigation label for the Flights section",
          defaultMessage: "Flights",
        })}
      />
      <Tab
        value="hotels"
        label={intl.formatMessage({
          description: "Navigation label for the Hotels section",
          defaultMessage: "Hotels",
        })}
      />
    </Tabs>
  );
};
